import { render, staticRenderFns } from "./papersCheck.vue?vue&type=template&id=7c514d2a&scoped=true&"
import script from "./papersCheck.vue?vue&type=script&lang=js&"
export * from "./papersCheck.vue?vue&type=script&lang=js&"
import style0 from "./papersCheck.vue?vue&type=style&index=0&id=7c514d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c514d2a",
  null
  
)

export default component.exports